import "App/routing/combineRoutesMap";
import { createBrowserHistory } from "history";
import { createReduxHistoryContext } from "redux-first-history";
const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
    history: createBrowserHistory(),
    savePreviousLocations: 2
});
export { createReduxHistory, routerMiddleware, routerReducer };
